import { render, staticRenderFns } from "./temperatureCard.vue?vue&type=template&id=87b2077a&"
import script from "./temperatureCard.vue?vue&type=script&lang=js&"
export * from "./temperatureCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports